import { put, take } from 'redux-saga/effects';
import { END } from 'redux-saga';
import { END as APP_END } from '../actions/app';

export default function* ssrSaga() {
  if (!__ISSERVER__) {
    return;
  }
  yield take(APP_END);

  yield put(END);
}
